import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface AuthModalContextType {
  isOpen: boolean;
  defaultTab: "register" | "login";
  openAuthModal: (tab?: "register" | "login") => void;
  closeAuthModal: () => void;
}

const AuthModalContext = createContext<AuthModalContextType | undefined>(undefined);

export const AuthModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [defaultTab, setDefaultTab] = useState<"register" | "login">("register");

  const openAuthModal = useCallback((tab: "register" | "login" = "register") => {
    setDefaultTab(tab);
    setIsOpen(true);
  }, []);

  const closeAuthModal = useCallback(() => setIsOpen(false), []);

  return (
    <AuthModalContext.Provider value={{ isOpen, defaultTab, openAuthModal, closeAuthModal }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => {
  const ctx = useContext(AuthModalContext);
  if (!ctx) throw new Error("useAuthModal must be used within AuthModalProvider");
  return ctx;
};
